import script from "./PolicyVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyVersion.vue?vue&type=script&setup=true&lang=js"

import "./PolicyVersion.vue?vue&type=style&index=0&id=7d18481c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d18481c"]])

export default __exports__